<!-- 图片组件 -->
<template>
  <div>
    <img class="q-image" :src="url" alt="" />
  </div>
</template>
<script>
export default {
  props: {
    url: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.q-image {
  width: 100%;
  height: auto;
  object-fit: contain;
}
</style>
